import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};


export function setBrandingPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_BRANDING_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function getBrandingConfigs(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_BRANDING_REQUESTED", "GET_BRANDING_SUCCESS", "GET_BRANDING_FAILED"],
        method: "POST",
        path: "admin/get_branding_configs",
        body: data
    });
}


export function deleteBrandingConfig(branding_config_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {branding_config_id: branding_config_id};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_BRANDING_REQUESTED", "DELETE_BRANDING_SUCCESS", "DELETE_BRANDING_FAILED"],
        method: "POST",
        path: "admin/delete_branding_config",
        body: data
    });
}

export function createBrandingConfig(branding_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_branding_config = branding_config;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_BRANDING_REQUESTED", "CREATE_BRANDING_SUCCESS", "CREATE_BRANDING_FAILED"],
        method: "POST",
        path: "admin/create_branding_config",
        body: data
    });
}

export function updateBrandingConfig(branding_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_branding_config = branding_config;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_BRANDING_REQUESTED", "UPDATE_BRANDING_SUCCESS", "UPDATE_BRANDING_FAILED"],
        method: "POST",
        path: "admin/update_branding_config",
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionBranding.js